import { Link, NavLink } from 'react-router-dom';
import { motion, useScroll, useTransform, useReducedMotion } from 'motion/react';

const navLinks = [
  { to: '/about', label: 'About us' },
  { to: '/pricing', label: 'Pricing' },
];

export function Nav() {
  const { scrollY } = useScroll();
  const reduce = useReducedMotion();
  const background = useTransform(scrollY, [0, 80], ['rgba(9,9,11,0)', 'rgba(9,9,11,0.8)']);
  const borderOpacity = useTransform(scrollY, [0, 80], [0, 1]);
  const blurPx = useTransform(scrollY, [0, 80], [0, 12]);
  const backdropFilter = useTransform(blurPx, (v) => `blur(${v}px)`);

  return (
    <motion.nav
      style={reduce ? undefined : { backgroundColor: background, backdropFilter }}
      className="sticky top-0 z-50"
    >
      <motion.div
        aria-hidden="true"
        style={reduce ? undefined : { opacity: borderOpacity }}
        className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-white/10"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="text-xl font-bold tracking-tight text-zinc-100">
            Chase it for me
          </Link>
          <div className="flex items-center gap-6">
            <div className="hidden sm:flex items-center gap-6">
              {navLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className={({ isActive }) =>
                    `text-sm font-medium transition-colors ${
                      isActive ? 'text-zinc-100' : 'text-zinc-400 hover:text-zinc-100'
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
            </div>
            <motion.a
              href="/app"
              whileHover={reduce ? undefined : { scale: 1.03 }}
              whileTap={reduce ? undefined : { scale: 0.97 }}
              className="px-4 py-2 bg-indigo-600 text-white rounded-lg font-medium shadow-sm shadow-indigo-600/30 hover:bg-indigo-500 transition-colors"
            >
              Log In
            </motion.a>
          </div>
        </div>
      </div>
    </motion.nav>
  );
}
